import { render } from "./ShipmentInfo.vue?vue&type=template&id=af820ed6&scoped=true"
import script from "./ShipmentInfo.vue?vue&type=script&lang=js"
export * from "./ShipmentInfo.vue?vue&type=script&lang=js"

import "./ShipmentInfo.vue?vue&type=style&index=0&id=af820ed6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af820ed6"]])

export default __exports__